import VarietySelect from "@/pages/components/VarietySelect";
import React, {useState} from "react";
import AppModal from "@/components/AppModal.tsx";
import PageBack from "@/components/PageBack";
import RpIcon from "@/components/RpIcon";
import RouteConstant from "@/constant/RouteConstant";
import {Stack, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import {useTranslation} from "react-i18next";

const VarietySelectModal = (props: any) => {
  const { open, onClose, onSelected, varietyOperate } = props
  const {t} = useTranslation()
  const [selected, setSelected] = useState(null);

  return (<>
    <AppModal open={open} onClose={onClose}>
      <Stack>
        <SimpleHeader
          title={varietyOperate == 'deposit' ? t('deposit') : t('withdraw')}
          closeButton={<RpIcon icon="close"
                               clickable
                               onClick={() => {
                                 props?.onClose();
                               }}
                               size={22} />}
          sx={{
            'border-top-left-radius': '12px',
            'border-top-right-radius': ' 12px',
          }}
        />
        {/*<Stack*/}
        {/*  sx={{height: '44px', padding: '0 16px'}}*/}
        {/*  direction="row" alignItems="center" justifyContent="space-between">*/}
        {/*  <RpIcon icon={'close'} size={24} clickable*/}
        {/*          onClick={() => {*/}
        {/*            onClose && onClose();*/}
        {/*          }}*/}
        {/*  />*/}
        {/*  <Typography*/}
        {/*  sx={{flex: 1, textAlign: "center" }}*/}
        {/*  >{varietyOperate == 'deposit' ? t('deposit') : t('withdraw')}</Typography>*/}
        {/*</Stack>*/}
        <Stack sx={{ padding: '16px' }}>
          <VarietySelect
            varietyOperate={varietyOperate}
            onSelect={(variety) => {
            setSelected(variety)
            onSelected && onSelected(variety)
          }} />
        </Stack>

      </Stack>

    </AppModal>
  </>)
}

export default VarietySelectModal
